module.exports = __webpack_public_path__ + "img/exact.9bf15330.png";